export enum CopyJobMode {
    FullCopy = 'Batch',
    IncrementalCopy = 'CDC',
    StreamCopy = 'StreamCopy'
}

export enum ChangeDetectionMethod {
    NATIVE_CDC = 'NATIVE_CDC',
    INCREMENTAL_COLUMN = 'INCREMENTAL_COLUMN'
}

export type CopyJobModeType = `${CopyJobMode}`;

export interface ICDCTable {
    source_schema?: string;
    source_table: string;
    capture_instance: string;
    supports_net_changes?: boolean;
}

export interface ICustomCaptureInstanceMapping {
    readonly id: string;
    readonly sourceDisplayName: string;
    readonly captureInstanceOptions: ReadonlyArray<{ label: string; value: string }>;
    captureInstanceName?: string;
}

export interface IRowMarkerValues {
    insert?: string;
    update_postimage?: string;
    update_preimage?: string;
    delete?: string;
}

export interface IGenericChangeDataProperties {
    rowMarkerColumn?: string;
    rowOrderColumn?: string;
    initialFolderName?: string;
    deltaFolderName?: string;
    rowMarkerValues?: IRowMarkerValues;
}
